module.exports = __webpack_public_path__ + "img/IMG_4928.4fbfbf25.jpg";